import React from "react";
import { WorkProjectShell } from "./WorkProjectShell";
import {
  WorkSplitRow,
  WorkMediaFrame,
  WorkTextStack,
  WorkSectionHeading,
  ConcludeContainer,
} from "./styles";
import { ProjectDetails } from "../../../DesignSystem/ProjectDetails";

export default function HoloworkAssist() {
  const ProjectBG = require("../../../../assets/videos/holowork-assist/poster.png");
  const T1 = require("../../../../assets/videos/holowork-assist/t1.png");
  const T2 = require("../../../../assets/videos/holowork-assist/t2.png");
  const T3 = require("../../../../assets/videos/holowork-assist/t3.png");

  return (
    <WorkProjectShell
      posterSrc={ProjectBG}
      title="HOLOWORK — mobile, HoloLens & WebGL"
      lead={
        <p>
          HOLOWORK ASSIST supports assembly, maintenance, and repair with mixed
          reality, interactive 3D, and AR—including spare-part flows and optional
          media libraries.
        </p>
      }
    >
      <WorkSplitRow>
        <WorkMediaFrame>
          <video controls poster={T1}>
            <source
              src="https://bharathvadde.s3.ap-south-1.amazonaws.com/holowork-assist/1_Holowork.mp4"
              type="video/mp4"
            />
          </video>
        </WorkMediaFrame>
        <WorkTextStack>
          <WorkSectionHeading>Mixed reality (HoloLens)</WorkSectionHeading>
          <p>
            Load the digital twin, pick a routine, and work with a life-size
            machine in the room—hands-free menus and clear step-by-step guidance.
          </p>
        </WorkTextStack>
      </WorkSplitRow>

      <WorkSplitRow $reverse>
        <WorkMediaFrame>
          <video controls poster={T2}>
            <source
              src="https://bharathvadde.s3.ap-south-1.amazonaws.com/holowork-assist/2_video.mp4"
              type="video/mp4"
            />
          </video>
        </WorkMediaFrame>
        <WorkTextStack>
          <WorkSectionHeading>Mobile (iOS & Android)</WorkSectionHeading>
          <p>
            Interactive 3D manuals and routines on phone or tablet—with offline
            support and updates when connected.
          </p>
        </WorkTextStack>
      </WorkSplitRow>

      <WorkSplitRow>
        <WorkMediaFrame>
          <video controls poster={T3}>
            <source
              src="https://bharathvadde.s3.ap-south-1.amazonaws.com/holowork-assist/3_video.mp4"
              type="video/mp4"
            />
          </video>
        </WorkMediaFrame>
        <WorkTextStack>
          <WorkSectionHeading>AR mobile</WorkSectionHeading>
          <p>
            Anchor virtual models to real objects and spaces for fit checks,
            disassembly order, torque hints, and fewer mistakes on the job.
          </p>
        </WorkTextStack>
      </WorkSplitRow>

      <ConcludeContainer>
        <p>
          Choose MR, mobile, or WebGL—one product family tailored to how your
          team works on the floor.
        </p>
      </ConcludeContainer>

      <ProjectDetails
        details={[
          { label: "Project Name", value: "HOLOWORK ASSIST" },
          { label: "Period", value: "09.2019 - 11.2019" },
          { label: "Client", value: "Remon" },
          { label: "Engine & Tools", value: "Unity, AR Foundation, C#" },
          { label: "Platform", value: "Mobile, Hololens" },
          { label: "Company", value: "Radiusmedia KG" },
          { label: "Tags", value: "AR, MR, WebGL" },
        ]}
      />
    </WorkProjectShell>
  );
}
